import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpResponse,
    HttpErrorResponse,
    HttpContextToken,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout, tap, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SpinnerService } from './spinner.service';
import { AppInsightsService } from './app-insights.service';

export const SKIP_SPINNER = new HttpContextToken<boolean>(() => false);

@Injectable({
    providedIn: 'root',
})
export class ErrorInterceptor implements HttpInterceptor {
    private readonly TIMEOUT_DURATION = 90000;
    private ongoingRequests = 0;

    constructor(
        private router: Router,
        private spinnerService: SpinnerService,
        private appInsightsService: AppInsightsService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const startTime = Date.now();
        this.ongoingRequests++;

        let customHeaders = request.headers;
        customHeaders = customHeaders.set('Content-Type', 'application/json');
        customHeaders = customHeaders.set('property', 'value');

        const clonedRequest = request.clone({
            headers: customHeaders,
        });

        const skipSpinner = request.context.get(SKIP_SPINNER);
        if (!skipSpinner) {
            this.spinnerService.show();
        }
        return next.handle(clonedRequest).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    const endTime = Date.now();
                    const duration = endTime - startTime;
                    //   console.log(`URL: ${request.url}`);
                    //   console.log(`Status: ${event.status}, Response Time: ${duration}ms`);
                    //   console.log('');
                }
            }),
            timeout(this.TIMEOUT_DURATION),
            catchError((error: any) => {
                let errorMessage = '';
                if (error.name === 'TimeoutError') {
                    errorMessage = error.message;
                } else if (error instanceof HttpErrorResponse) {
                    if (error.error instanceof ErrorEvent) {
                        errorMessage = `Client-side error: ${error.error.message}`;
                    } else {
                        errorMessage = `Server-side error: ${error.status} - ${error.error}`;
                    }

                    this.appInsightsService.logException(error, errorMessage);
                    console.error(errorMessage);
                }
                return throwError(() => new Error('Something went wrong; please try again later.'));
            }),
            finalize(() => {
                this.ongoingRequests--;
                if (this.ongoingRequests === 0) {
                    this.spinnerService.hide();
                }
            })
        );
    }
}
